var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8327 12.4993C16.2929 12.4993 16.666 12.8724 16.666 13.3327V16.3208L17.3265 15.6603L18.5053 16.8386L16.4219 18.9219C16.0965 19.2474 15.5689 19.2474 15.2434 18.9219L13.1601 16.8386C12.8347 16.5132 12.8347 15.9855 13.1601 15.6601C13.4855 15.3347 14.0132 15.3347 14.3386 15.6601L14.9993 16.3208V13.3327C14.9993 12.8724 15.3724 12.4993 15.8327 12.4993ZM18.5053 16.8386C18.8307 16.5132 18.8307 15.9855 18.5053 15.6601C18.1798 15.3347 17.652 15.3349 17.3265 15.6603L18.5053 16.8386Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83268 13.3327C4.45197 13.3327 3.33268 14.452 3.33268 15.8327V17.4993C3.33268 17.9596 2.95959 18.3327 2.49935 18.3327C2.03911 18.3327 1.66602 17.9596 1.66602 17.4993V15.8327C1.66602 13.5315 3.5315 11.666 5.83268 11.666H12.4993C12.9596 11.666 13.3327 12.0391 13.3327 12.4993C13.3327 12.9596 12.9596 13.3327 12.4993 13.3327H5.83268Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74935 3.33268C7.36864 3.33268 6.24935 4.45197 6.24935 5.83268C6.24935 7.21339 7.36864 8.33268 8.74935 8.33268C10.1301 8.33268 11.2493 7.21339 11.2493 5.83268C11.2493 4.45197 10.1301 3.33268 8.74935 3.33268ZM4.58268 5.83268C4.58268 3.5315 6.44816 1.66602 8.74935 1.66602C11.0505 1.66602 12.916 3.5315 12.916 5.83268C12.916 8.13387 11.0505 9.99935 8.74935 9.99935C6.44816 9.99935 4.58268 8.13387 4.58268 5.83268Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerNewIcon);
export default __webpack_public_path__ + "static/media/customerNewIcon.c571378b3cceca4b6b284578bbe4ba68.svg";
export { ForwardRef as ReactComponent };